/* Inprint: copies the Vitals Recently Viewed price into its Add to Cart button and keeps it in sync
   (variant changes, Vitals re-rendering the button text). Only the amount is taken, not the hidden
   "Regular price" / "Sale price" labels; when a sale shows two amounts, the last (current) one is used. */
(function () {
  var MONEY = /(?:[€$£]|A\$|C\$|NZ\$|EUR|USD|GBP|CAD|AUD|NZD)\s?\d[\d.,]*\d|\d[\d.,]*\d\s?(?:€|EUR|USD|GBP|CAD|AUD|NZD)/g;

  function readPrice(el) {
    var matches = el.textContent.replace(/\u00a0/g, ' ').match(MONEY);
    return matches ? matches[matches.length - 1].trim() : '';
  }

  function sync(card) {
    var priceEl = card.querySelector('.vtl-product-card__price');
    var button = card.querySelector('.vtl-product-card__atc-button');
    if (!priceEl || !button) return;
    var price = readPrice(priceEl);
    var span = button.querySelector('.inprint-atc-price');
    if (!price) {
      if (span) span.remove();
      return;
    }
    if (!span) {
      span = document.createElement('span');
      span.className = 'inprint-atc-price';
      button.appendChild(span);
    }
    if (span.textContent !== price) span.textContent = price;
  }

  function run() {
    document.querySelectorAll('.vtl-rv-main-widget .vtl-product-card').forEach(sync);
  }

  var scheduled = false;
  var observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      run();
    });
  });

  function start() {
    run();
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
